import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { Color, theme } from '../../constants'
import { Heading } from '../Heading'

const StyledHeading = styled(Heading)({
  gridArea: 'Header',
  padding: `${theme.spacing[3]}px ${theme.spacing[3]}px`,
})

export const Header = ({
  title,
  color = Color.CHARCOAL,
}: {
  title: ReactNode
  color?: Color
}) => {
  return (
    <StyledHeading my="auto" level={4} color={color}>
      {title}
    </StyledHeading>
  )
}
